import React, { Component } from "react";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ScrollAnimation from "react-animate-on-scroll";
import { Styles } from "./styles/organogram.js";

class Organogram extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper organogram-page">
          {/* Header */}
          <Header />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Organogram" img="slider1.jpg" />

          {/* Organogram Content */}
          <section className="organogram-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <ScrollAnimation animateIn="fadeInUp" duration={1}>
                    <div className="organogram-content">
                      <div className="organogram-header">
                        <h2 className="organogram-title">Organogram</h2>
                        <p className="organogram-subtitle">
                          CWIS-FSM Support Cell - DPHE Organizational Structure
                        </p>
                      </div>

                      <div className="org-chart">
                        {/* Yellow Header */}
                        {/* <div className="org-header-yellow">
                          <h1>Organogram</h1>
                        </div> */}

                        <div style={{width: "100%", height: "auto"}}>
                          <img
                          style={{width: "100%", height: "auto"}}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/organogram.jpg`
                          }
                          className="organogram"
                          alt=""
                        />
                        </div>
                      </div>
                    </div>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </section>

          {/* Footer */}
          <Footer />
        </div>
      </Styles>
    );
  }
}

export default Organogram;
